import {gql} from '@apollo/client'
import React from 'react'
import styled from 'styled-components'
import {ButtonGroup} from '../../../../components/form'
import {Button} from '../../../../components/library/buttons'
import {CopyInput} from '../../../../components/library/copy'
import {Modal} from '../../../../components/library/modal/modal'
import {InviteLinkModalMemberFragment} from './generated/invite-link-modal'

const Description = styled.p`
  margin: '0 0 20px';
  color: ${p => p.theme.grey50};
`

const Email = styled.span`
  color: ${p => p.theme.blue};
`

export const InviteLinkModal = ({
  member,
  handleClose
}: {
  member: InviteLinkModalMemberFragment
  handleClose: () => void
}) => {
  const inviteLink = `${window.location.protocol}//${window.location.host}/signup/${member.inviteSecret}`

  return (
    <Modal
      title="Invite link"
      handleClose={handleClose}
      style={{
        width: '400px'
      }}
    >
      <>
        <Description>
          To invite <Email>{member.email}</Email> to Atomic, send them this
          share link.
        </Description>

        <div>
          <CopyInput value={inviteLink} />
        </div>

        <ButtonGroup>
          <Button appearance={'primary'} size={'large'} onClick={handleClose}>
            Done
          </Button>
        </ButtonGroup>
      </>
    </Modal>
  )
}

InviteLinkModal.fragments = {
  member: gql`
    fragment InviteLinkModalMember on BusinessUser {
      email
      inviteSecret
    }
  `
}
